import React, { useState } from 'react';
import './CustomSecureInput.css';

const CustomSecureInput = ({
    label,
    placeholder,
    icon: Icon,
    eyeIcon: EyeIcon,
    onChange,
}) => {
    const [value, setValue] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const handleChange = (e) => {
        setValue(e.target.value);
        onChange(e.target.value);
    };

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prevVisibility) => !prevVisibility);
    };

    return (
        <div className="input-field">
            <label className="input-label">{label}</label>
            <div className="input-container">
                <span className="input-icon">
                    <Icon />
                </span>
                <input
                    type={isPasswordVisible ? 'text' : 'password'}
                    className="input-text"
                    placeholder={placeholder}
                    value={value}
                    onChange={handleChange}
                />
                <span className="eye-icon" onClick={togglePasswordVisibility}>
                    <EyeIcon />
                </span>
            </div>
        </div>
    );
};

export default CustomSecureInput;
